// header fixed on scroll
$(document).ready(function () {
  Change_Flag();
  $(".my-cart").click(function () {
    updateCartDrawer();
    $(".cart-box").addClass("cart-display");
  });
  $(".cart-box .fa-times").click(function () {
    $(".cart-box").removeClass("cart-display");
  });

  $(".tab-menu-open").click(function () {
    $(".nav-menu").addClass("tab-menu-display");
    $(".nav-menu").removeClass("nav-menu-none");
    $("body").addClass("sm-body-scrollbar");
  });

  $(".cross-icon").click(function () {
    $(".nav-menu").addClass("nav-menu-none");
    $(".nav-menu").removeClass("tab-menu-display");
    $("body").removeClass("sm-body-scrollbar");
  });
  
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $("#scroll").fadeIn();
    } else {
      $("#scroll").fadeOut();
    }
  });
  $("#scroll").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
  $(".searchbar").click(function () {
        document.getElementById("searchBlockSmall").style.width = "100%";
        var overlay = jQuery('<div id="overlay"> </div>');

        overlay.appendTo('.page-container');
        $("#searchBlockSmall").css('z-index','22333');
  });
  $(document).mouseup(function(e) {
      var container = $(".cart-box,.my-cart");
      
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
          $(".cart-box").removeClass("cart-display");
      }
  });

  //------------------------------- less & more features js - PDP Page------------------------------- 
  $(".toggle-more").click(function() {
    var elem = $(".toggle-more").text();
    if (elem == "More Features") {
      //Stuff to do when btn is in the read more state
      $(".toggle-more").text("Less Features");
      $("#pdp-feature-list ul li:gt(2)").slideDown();
    } else {
      //Stuff to do when btn is in the read less state
      $(".toggle-more").text("More Features");
      $("#pdp-feature-list ul li:gt(2)").slideUp();
    }
  });
  if ($('#pdp-feature-list > ul > li').length > 3) {
    $('.toggle-more').show();
  }
  else{
    $('.toggle-more').hide();
  }
      
  $('.main-img-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    fade: true,
    autoplay: false,adaptiveHeight: true,
    autoplaySpeed: 4000,
    speed: 300,
    lazyLoad: 'ondemand',
    asNavFor: '.thumb-nav'
  });
  // Thumbnail/alternates slider for product page
  $('.thumb-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    centerPadding: '0px',
    asNavFor: '.main-img-slider',
    dots: false,
    centerMode: false,
    draggable: true,
    speed: 200,
    focusOnSelect: true,
  });

  var preloader = document.getElementById('loader');

  /*---- carousel css - To Fix overlap text issue when click next & previous slide---   */
  $('.carousel').on('slide.bs.carousel', function () {
   $('.carousel-control').addClass('disabled');
  });

  $('.carousel').on('slid.bs.carousel', function () {
    $('.carousel-control').removeClass('disabled');
  });
});

// document.addEventListener("DOMContentLoaded", Change_Flag());

function Change_Flag() {
  if($('html').attr('lang') == 'es'){
    $('.announcement-bar').find('.fflag').removeClass('fflag-EU fflag');
    var img = document.createElement("img");
    img.src = "https://cdn.shopify.com/s/files/1/0075/5302/4066/files/flagg-es.png?v=1678364706";
    $('.announcement-bar .custom_flag').html(img);
  }
  else if ($('html').attr('lang') == 'de'){
    $('.announcement-bar').find('.fflag').removeClass('fflag-EU fflag');
    var img = document.createElement("img");
    img.src = "https://cdn.shopify.com/s/files/1/0075/5302/4066/files/flag-de.png?v=1678366749";
    $('.announcement-bar .custom_flag').html(img);  
  }
  else if($('html').attr('lang') == 'fr'){
    $('.announcement-bar').find('.fflag').removeClass('fflag-EU fflag');
    var img = document.createElement("img");
    img.src = "https://cdn.shopify.com/s/files/1/0075/5302/4066/files/flag-fr.png?v=1678366983";
    $('.announcement-bar .custom_flag').html(img);
  }
}

// search open block
function openNav() {
  document.getElementById("searchBlock").style.width = "100%";
}

function closeNav() {
  document.getElementById("searchBlockSmall").style.width = "0";
  document.getElementById("searchBlock").style.width = "0";
  $('#overlay').remove();
}

//quantity counter code
$(document).on("click", ".ajax-cart-item__minus-quantity", function (e) {
  decrementValue(e);
});
$(document).on("click", ".ajax-cart-item__add-quantity", function (e) {
  incrementValue(e);
});
$(document).on("click", ".cart-dropdown-remove .remove", function (e) {
  setTimeout(function() {
    updateCartDrawer();
  }, 1000);
});

function incrementValue(e) {
  e.preventDefault();
  var parent = $(e.target).closest("div");
  var currentVal = parseInt(parent.find(".ajax-cart-item__input-quantity").val(), 10);
  var currentVariant = $(e.target).attr("data-variant");

  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          quantity: currentVal + 1,
          id: currentVariant
      },
      success: function(cart) {
        setTimeout(function() {
          updateCartDrawer();
        }, 1000);
      }
  });
  
  if (!isNaN(currentVal)) {
    parent.find(".ajax-cart-item__input-quantity").val(currentVal + 1);
  } else {
    parent.find(".ajax-cart-item__input-quantity").val(0);
  }
}
function decrementValue(e) {
  e.preventDefault();
  
  var parent = $(e.target).closest("div");
  var currentVal = parseInt(parent.find(".ajax-cart-item__input-quantity").val(), 10);
  var currentVariant = $(e.target).attr("data-variant");

  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
          quantity: currentVal - 1,
          id: currentVariant
      },
      success: function(cart) {
        setTimeout(function() {
          updateCartDrawer();
        }, 1000);
      }
  });
  
  if (!isNaN(currentVal) && currentVal > 0) {
    parent.find(".ajax-cart-item__input-quantity").val(currentVal - 1);
  } else {
    parent.find(".ajax-cart-item__input-quantity").val(0);
  }
}

$(document).ready(function () {
  $(".accordion-button").click(function () {
    $(this).addClass("Hello");
    $(this).toggleClass("bluecolor");
  });
});

// filter for mobile device
function openFilter() {
  document.getElementById("filterOption").style.width = "100%";
}

function closeFilter() {
  document.getElementById("filterOption").style.width = "0";
}

//start js code for desktop menu as samsung

  function handleClick(id, index){        
      let previousChild = document.getElementById(id).previousElementSibling;
      //previousChild.style.borderBottom = "none";
     $( "#"+id ).prev().css( "border-bottom", "none" );
      if(index !== "1"){
          let tabId = id;
          let value = tabId.split("-tab");
          let newId = value[0];
          $( "#"+newId ).css( "border-radius", "18px" );
          //document.getElementById(newId).style.borderRadius = "18px";
      }
  }
  
  function handleClose(id) {
   $('.dropdown-content').hide();
  }

  function handleHover(id) {
      $(".backpacks-value").addClass("default-opacity");
      $(".dropdown-content").css("display", "none");
      document.getElementById(id).style.display = "block";
  }

function openSubMenu(id) {
    $(".default-opacity").removeClass("default-opacity");
    $(".right-arrow").addClass(id + "-arrow close");

    $(".active").removeClass("link-active-color");
    $("#" + id + "-link").addClass("link-active-color");

    $(".parent-li").removeClass("nav-li-design");
    $("#" + id + "-li").addClass("nav-li-design");

    $("#" + id + "-arrow").removeClass(id + "-arrow close");
    $("#" + id + "-arrow").addClass(id + "-arrow open");
    $("._listImage").addClass(id + "-value close");
    $("._listItem").addClass(id + "-value close");
    $("#" + id + "-list").removeClass(id + "-value close")
    $("#" + id + "-list").addClass(id + "-value open")
    $("#" + id + "-image").removeClass(id + "-value close")
    $("#" + id).addClass("addActiveColor");
}



function closeSubMenu(id, id2) {
  $("#backpacks-list").addClass("default-opacity");
}

window.addEventListener('fs-custom-events-product-added-to-cart', (e) => {updateCartDrawer();});

  // ------------------------------slick slider js------
  var maxHeight = -1;
  $('.slick-slide').each(function() {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  $('.slick-slide').each(function() {
    if ($(this).height() < maxHeight) {
      $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
    }
  });
  
  $(function () {
    $('.lazy').Lazy();
  }); 

// ----------------------------------------- Dropdown menu---------------------
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.dropdown-menu').forEach(function (element) {
    element.addEventListener('mouseover', function (e) {
      e.stopPropagation();
    });
  })

});

document.addEventListener("shopify:section:load", function(event) {
  $('.lazy').Lazy();
  $(".slick", ".vertical-slider").slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false
  });
  document.addEventListener('DOMContentLoaded', () => {
    var API = new Mmenu("#menu", {
    extensions: ["theme-light", "position-front", "position-left" , "border-none"],
    navbar: { title: "Menu" },
    navbars: [true],
    offCanvas: {
    page: {
    nodetype: "section"
    }
    }
    },
    {
    searchfield: { clear: true }
    });
});
});